import { EventQuery } from "lib/build/events";

export const queries: { [key: string]: EventQuery } = {
	status: {
		interpretation: { vocab: "ktx", code: "patient_status" }
	},
	address: {
		interpretation: { vocab: "snomed", code: "184097001" }
	},
	weight: {
		interpretation: { vocab: "ktx", code: "weight" }
	},
	ab0: {
		interpretation: { vocab: "ktx", code: "ab0" }
	},
	rh: {
		interpretation: { vocab: "ktx", code: "rh" }
	},
	waitingListStartDate: {
		interpretation: { vocab: "ktx", code: "waiting_list_start_date" }
	},
	statusByNephrologist: {
		interpretation: { vocab: "ktx", code: "patient_status_by_nephrologist" }
	}
};
